export default __webpack_public_path__ + "static/media/927.f2ce90a5.gif";